import React from 'react';
import { reorderIcon, PathElement } from '@chordbaker/design';

interface ReorderIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const paths = reorderIcon.elements as PathElement[];

/** Up and down arrows: "Reorder chart", which opens the reorder sheet. */
const ReorderIcon: React.FC<ReorderIconProps> = ({
  size = reorderIcon.defaultSize,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={reorderIcon.viewBox}
    fill={reorderIcon.fill}
    stroke={color}
    strokeWidth={reorderIcon.strokeWidth}
    strokeLinecap={reorderIcon.strokeLinecap as React.SVGAttributes<SVGSVGElement>['strokeLinecap']}
    strokeLinejoin={reorderIcon.strokeLinejoin as React.SVGAttributes<SVGSVGElement>['strokeLinejoin']}
    className={className}
    aria-hidden="true"
  >
    {paths.map(path => (
      <path key={path.d} d={path.d} />
    ))}
  </svg>
);

export default ReorderIcon;
